<div class="c-proxy-hosting-info">
	<div class="bg-container">
		<img src="{{@shared.assetsHost}}/img/proxy/info-logo.svg">
	</div>

	<div class="info">
		<div class="info-title">Custom CDN Endpoints</div>
		<div class="info-text">
			We can work together and setup a custom configuration for your project. This way, you
			can have full control over your files and the ability to utilize the full power of jsDelivr.
		</div>
		<div class="info-text">
			This kind of custom hosting can be suitable for:
		</div>
		<div class="info-subtitle">
			<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.svg">
			Binary hosting. Windows executable files and zips
		</div>
		<div class="info-subtitle">
			<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.svg">
			Frequently updated files
		</div>
		<div class="info-subtitle">
			<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.svg">
			Projects that can't follow jsDelivr file structure
		</div>
		<div class="info-subtitle">
			<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/check-circle.svg">
			Some other use that will blow all of our minds.
		</div>

		<div class="info-text">
			Simply send an email to <a href="mailto:d@jsdelivr.com">d@jsdelivr.com</a> with a request for more information.
		</div>
	</div>
</div>
